<div class="flex align-items-center justify-content-center date-scroller">
    <app-button
        icon="pi-chevron-left"
        [rounded]="true"
        [text]="true"
        [severity]="'secondary'"
        [disabled]="disabled()"
        (clickEvent)="move(-1)"
    ></app-button>

    <p-popover #datePopover (onShow)="syncPickerMonths()">
        <div class="flex-column align-items-center">
            @if (enablePeriodChange()) {
                <div class="flex gap-small align-items-center p-3 period-change">
                    <app-number-input
                        [formField]="periodForm.length"
                        label="inputs.periodLength"
                        [min]="1"
                        [showButtons]="true"
                        (valueChange)="onPeriodLengthChange($event)"
                    ></app-number-input>
                    <div class="flex gap-small">
                        <app-button
                            label="inputs.periodOptions.day"
                            size="small"
                            [outlined]="activePeriod() !== TimePeriodEnum.Day"
                            (clickEvent)="setPeriod(TimePeriodEnum.Day)"
                        ></app-button>
                        <app-button
                            label="inputs.periodOptions.week"
                            size="small"
                            [outlined]="activePeriod() !== TimePeriodEnum.Week"
                            (clickEvent)="setPeriod(TimePeriodEnum.Week)"
                        ></app-button>
                        <app-button
                            label="inputs.periodOptions.month"
                            size="small"
                            [outlined]="activePeriod() !== TimePeriodEnum.Month"
                            (clickEvent)="setPeriod(TimePeriodEnum.Month)"
                        ></app-button>
                    </div>
                </div>
            }

            <p-datePicker
                [ngModel]="pickerSelection()"
                [inline]="true"
                [firstDayOfWeek]="1"
                selectionMode="range"
                [view]="pickerView()"
                [numberOfMonths]="pickerMonthCount()"
                [responsiveOptions]="pickerResponsiveOptions"
                class="date-scroller-panel"
                (onSelect)="select($event, datePopover)"
            ></p-datePicker>
        </div>
    </p-popover>

    <button
        type="button"
        class="date-value"
        [disabled]="disabled()"
        (click)="datePopover.toggle($event)"
    >
        @if (singleMonth()) {
            {{ range().dateFrom | localDate : 'LLLL y' }}
        } @else if (singleDay()) {
            {{ range().dateFrom | localDate : 'weekday' }}&nbsp;{{ range().dateFrom | shortDate }}
        } @else {
            {{ range().dateFrom | localDate : 'weekday' }}&nbsp;{{ range().dateFrom | shortDate }}
            -
            {{ range().dateTo | localDate : 'weekday' }}&nbsp;{{ range().dateTo | shortDate }}
        }
    </button>

    <app-button
        icon="pi-chevron-right"
        [rounded]="true"
        [text]="true"
        [severity]="'secondary'"
        [disabled]="disabled()"
        (clickEvent)="move(1)"
    ></app-button>
</div>
